import { ReleaseCard } from "@components/cards/ReleaseCard";
import { useMediaQuery } from "@lib/hooks/useMediaQuery";
import { Release } from "@models/release";
import { device } from "@styles/theme";
import { Description, GridRow, Wrapper } from "./ReleaseGrid.style";
import { useState } from "react";

interface Props {
	title?: React.ReactNode | string;
	description?: string;
	data: Release[];
	isLoading: boolean;
	wideGrid?: boolean;
	columnSizes?: {
		xsm?: number;
		sm?: number;
		md?: number;
		lg?: number;
		xl?: number;
		xxl?: number;
	};
	location?: string;
}

const ReleaseGrid: React.FC<Props> = ({
	title,
	description,
	data,
	wideGrid,
	columnSizes,
	location,
}) => {
	// allow only one release to have controls open
	const [itemControlsOpen, setItemControlsOpen] = useState<number>();
	// we use device width to determine chunk size
	const isSm = useMediaQuery({ query: device.sm });
	const isMd = useMediaQuery({ query: device.md });
	const isLg = useMediaQuery({ query: device.lg });
	const isXl = useMediaQuery({ query: device.xl });
	const isXxl = useMediaQuery({ query: device.xxl });

	let columnSize = columnSizes?.xsm ? columnSizes?.xsm : 2; // starting from smalest screen so 2 cards per row to display
	if (isXxl) {
		columnSize = columnSizes?.xxl ? columnSizes?.xxl : wideGrid ? 7 : 5; // 5 cards per row
	} else if (isXl) {
		columnSize = columnSizes?.xl ? columnSizes?.xl : wideGrid ? 7 : 5; // 5 cards per row
	} else if (isLg) {
		columnSize = columnSizes?.lg ? columnSizes?.lg : wideGrid ? 6 : 4; // on lg (1024px width) show 4 cards per row
	} else if (isMd) {
		columnSize = columnSizes?.md ? columnSizes?.md : wideGrid ? 4 : 3; // starting from sm screen we show 3 cards per row
	} else if (isSm) {
		columnSize = columnSizes?.sm ? columnSizes?.sm : wideGrid ? 4 : 3; // starting from sm screen we show 3 cards per row
	}

	const rowItems: Array<Release[]> = [];
	for (let i = 0; i < data.length; i += columnSize) {
		const c = data.slice(i, i + columnSize).filter((item) => item !== null);
		rowItems.push(c);
	}

	return (
		<Wrapper>
			{title}
			{description && description !== "" && (
				<Description>{description}</Description>
			)}
			{rowItems.map((row, index) => (
				<GridRow key={`release-grid-chunk-${index}`}>
					{row.map((item) => {
						return (
							<ReleaseCard
								index={index}
								key={`charts-grid-card${item.id}`}
								location={location}
								release={item}
								itemControlsOpen={itemControlsOpen}
								setItemControlsOpen={setItemControlsOpen}
							/>
						);
					})}
				</GridRow>
			))}
		</Wrapper>
	);
};

export default ReleaseGrid;
